function stringToColor(str: string) {
  // Simple hash function to get a number from the string
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  // Convert hash to hex color
  let color = '#'
  for (let i = 0; i < 3; i++) {
    // eslint-disable-next-line no-bitwise
    const value = (hash >> (i * 8)) & 0xff
    color += `00${value.toString(16)}`.slice(-2)
  }
  return color
}

function getInitials(email: string) {
  if (!email) return ''
  const [first, second] = email.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
  return (first || '') + (second || '')
}

export function generateLetterAvatar(email?: string, size = 64) {
  if (!email) return ''
  const initials = getInitials(email)
  const bgColor = stringToColor(email || 'default')
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${size}' height='${size}'><rect width='100%' height='100%' fill='${bgColor}'/><text x='50%' y='50%' font-size='${
    size * 0.5
  }' fill='white' text-anchor='middle' dominant-baseline='central' font-family='Arial, sans-serif'>${initials}</text></svg>`
  // URI-encode the SVG
  const encoded = encodeURIComponent(svg)
    .replace(/'/g, '%27')
    .replace(/"/g, '%22')
  return `data:image/svg+xml;utf8,${encoded}`
}
